import React, { useState, useEffect, useRef, useCallback } from 'react';
// Build version: 2026-04-25-v1 - Correction gate for failed training orders
import ScoreChecker from './scoreChecker.js';

import { useLocation } from 'react-router-dom';


import { Routes, Route } from "react-router-dom";

import axios from 'axios';
import logo from './assets/brand/pacific-pearl-logo.png';
import './App.css';
import io from 'socket.io-client';
import  OrderTable  from './LineItemsTable.js';
import ReceiptPreview from './ReceiptPreview.js';
import TrainerReviews from './TrainerReviews.js';
import TraineeLanding from './TraineeLanding.js';
import styled from 'styled-components';

import { css } from "@emotion/react";
import ClipLoader from "react-spinners/ClipLoader";

import OrderToAudio from './OrderToAudio.js';

import html2canvas from 'html2canvas';

// import TwilioPhone from './TwilioPhone'; 

import AudioMixer from './AudioMixer';

import {ShopifyProvider} from '@shopify/hydrogen-react';
import {CartProvider} from '@shopify/hydrogen-react';

const TRAINEE_POS_URL = process.env.REACT_APP_TRAINEE_POS_URL || 'https://order-taking-2026-66217e6b27756711050e.o2.myshopify.dev/agent-dashboard';

const buildTraineePosUrl = (callerNumber) => {
  const normalizedCallerNumber = String(callerNumber || '').replace(/\D/g, '');
  if (!normalizedCallerNumber) return TRAINEE_POS_URL;

  try {
    const url = new URL(TRAINEE_POS_URL);
    url.searchParams.set('trainingPhone', normalizedCallerNumber);
    return url.toString();
  } catch (error) {
    const separator = TRAINEE_POS_URL.includes('?') ? '&' : '?';
    return `${TRAINEE_POS_URL}${separator}trainingPhone=${encodeURIComponent(normalizedCallerNumber)}`;
  }
};

const REVIEW_ISSUE_OPTIONS = [
  {
    id: 'audio_missing_item',
    label: 'Audio missed item',
    description: 'The customer audio or transcript did not mention an item shown in the real order.'
  },
  {
    id: 'audio_missing_modifier',
    label: 'Audio missed request',
    description: 'The audio or transcript did not mention a side, modifier, sauce, or special request.'
  },
  {
    id: 'pickup_delivery_mismatch',
    label: 'Pickup/delivery mismatch',
    description: 'The audio said pickup/delivery differently from the real order.'
  },
  {
    id: 'pos_option_missing',
    label: 'POS option missing',
    description: 'The needed POS option could not be found or selected.'
  },
  {
    id: 'comparison_false_mismatch',
    label: 'Wrong mismatch',
    description: 'The two orders look the same, but the system marked them different.'
  },
  {
    id: 'wrong_real_order',
    label: 'Wrong real order',
    description: 'The system matched the trainee order against the wrong real order.'
  },
  {
    id: 'price_total_problem',
    label: 'Price/total problem',
    description: 'The item price, delivery fee, tax, or total looks wrong.'
  },
  {
    id: 'other_trainer_review',
    label: 'Other trainer review',
    description: 'The issue is not listed, but the note clearly explains the problem.'
  }
];


// class ErrorBoundary extends Component {
//   constructor(props) {
//     super(props);
//     this.state = { hasError: false };
//   }

//   static getDerivedStateFromError(error) {
//     return { hasError: true };
//   }

//   componentDidCatch(error, info) {
//     // Log error to monitoring service
//     console.log(error, info);
//   }

//   render() {
//     if (this.state.hasError) {
//       // You can render a fallback UI here
//       return <h1>Something went wrong.</h1>;
//     }

//     return this.props.children;
//   }
// }





const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;


const CoolBorder = styled.div`
  border: ${props => props.$border ? '1px solid red' : '1px solid #e0e0e0'}; /* A light border for that subtle charm */
  padding: 5px; /* Some breathing room */
  background-color: #fafafa; /* A background that's easy on the eyes */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* A touch of shadow for depth */
  background-color: rgba(255, 255, 255, 0.2); /* 50% transparency, 100% awesomeness */
  border-radius: 15px;
  margin: 10px;
`;

const OrderTableStyled = styled.div`
  max-width: 49%; // This allows for 2 components side by side with a 10px gap in between
  width: 100%;
  margin: 5px;
  @media (max-width: 600px) {
    max-width: 100%;
  }
`;
const StyledButton = styled.button`
    line-height: 1.5em;
    max-width: 75%;
    margin: 5px;
    font-size: 0.6em;
    font-weight: 500;
    padding: 10px;
    color: white;
    background: linear-gradient(to right, #007BFF, #0096FF);
    border: none;
    border-radius: 15px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    transition: all 0.3s ease-out;
    position: relative;
    overflow: hidden;
    
    &:hover {
        box-shadow: 0 15px 25px rgba(0, 0, 0, 0.2);
    }

    &:active {
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
        transform: translateY(4px);
    }

    &:disabled {
        background: #9e9e9e;
        box-shadow: none;
        cursor: not-allowed;
        opacity: 0.75;
        transform: none;
    }

    @media (max-width: 600px) {
        width: 100%;
    }
	`;

const LandingReturnButton = styled.button`
  margin: 10px auto 14px;
  padding: 10px 16px;
  color: #163c2c;
  background: #ffffff;
  border: 2px solid #2f7f56;
  border-radius: 10px;
  font-size: 0.72em;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);

  &:hover {
    background: #eff8f2;
  }
`;

const ScoreContainer = styled.div`
  padding: 10px;
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.2); /* Consistent with CoolBorder */
`;

const TranscriptContainer = styled.div`
  padding: 15px;
  margin: 10px 0;
  width: 100%;
  max-width: 100%;
  flex: 0 0 100%;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: #fff8e1; /* Solid light yellow background for visibility in screenshots */
  border: 2px solid #ffc107; /* Gold border to highlight the transcript */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;

  & > p {
    margin: 5px;
    font-weight: bold;
    font-size: 15px;
    text-align: center;
    word-wrap: break-word;
    max-width: 100%;
  }
`;



const ScoreHeading = styled.h3`
  color: #007BFF; /* Picking up the blue from your gradient button */
  font-weight: 600;
  margin: 5px;
`;

const ScoreDetail = styled.p`
  color: #333; /* A darker text for contrast */
  font-size: 0.8em; /* Slightly smaller than the heading */
  margin: 2px 0; /* A little space between lines */
`;


const ReviewRequest = styled.p`
  font-size: 2em;
  font-weight: bold;
`;

const ReviewNoteContainer = styled.div`
  background-color: #fff3cd;
  border: 3px solid #ffc107;
  padding: 15px 20px;
  border-radius: 10px;
  margin: 10px 0 15px 0;
  width: 100%;
  box-sizing: border-box;
`;

const ReviewNoteTitle = styled.h3`
  color: #856404;
  margin: 0 0 10px 0;
  font-size: 1.2em;
  font-weight: 600;
`;

const ReviewNoteText = styled.p`
  font-size: 1.1em;
  font-weight: 500;
  color: #333;
  margin: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
`;

const TraineeInfoContainer = styled.div`
  background-color: #e3f2fd;
  border: 2px solid #2196f3;
  padding: 10px 15px;
  border-radius: 8px;
  margin: 10px 0;
`;

const TraineeInfoText = styled.p`
  font-size: 1em;
  color: #1565c0;
  margin: 5px 0;
`;

const OrderTotalsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin: 10px 0;
  gap: 20px;
  flex-wrap: wrap;
`;

const OrderTotalBox = styled.div`
  flex: 1;
  max-width: 48%;
  min-width: 200px;
  padding: 10px 16px;
  background: ${props => props.$isTrainee ? '#e3f2fd' : '#e8f5e9'};
  border: 2px solid ${props => props.$isTrainee ? '#2196f3' : '#4caf50'};
  border-radius: 10px;
  text-align: center;

  h4 {
    margin: 0 0 6px 0;
    font-size: 0.9em;
    color: ${props => props.$isTrainee ? '#1565c0' : '#2e7d32'};
  }
  p {
    margin: 2px 0;
    font-size: 0.8em;
    color: #333;
  }
  .total-amount {
    font-size: 1.2em;
    font-weight: 700;
    color: ${props => props.$isTrainee ? '#1565c0' : '#2e7d32'};
  }
`;

const ReceiptSection = styled.div`
  display: flex;
  justify-content: center;
  margin: 15px 0 5px 0;
`;

const CorrectionGate = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin: 12px 0;
  max-width: ${props => props.$top ? '760px' : '100%'};
  padding: 16px 20px;
  background: #fff8e1;
  border: 3px solid #ff9800;
  border-radius: 10px;
  color: #333;
  text-align: center;
`;

const CorrectionTitle = styled.h3`
  margin: 0 0 8px 0;
  color: #b26a00;
  font-size: 1.2em;
`;

const CorrectionText = styled.p`
  margin: 4px auto 12px auto;
  max-width: 820px;
  font-size: 0.9em;
  line-height: 1.45;
`;

const CorrectionActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const CorrectionButton = styled.button`
  padding: 10px 18px;
  border-radius: 10px;
  border: 2px solid ${props => props.$secondary ? '#d84315' : '#1565c0'};
  background: ${props => props.$secondary ? '#fff' : '#1565c0'};
  color: ${props => props.$secondary ? '#d84315' : '#fff'};
  cursor: pointer;
  font-size: 0.85em;
  font-weight: 600;

  &:disabled {
    border-color: #aaa;
    background: #ddd;
    color: #777;
    cursor: not-allowed;
  }
`;

const CorrectionStatus = styled.p`
  margin: 10px 0 0 0;
  color: #555;
  font-size: 0.8em;
`;

const CorrectionBlockedFooter = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin: 24px auto;
  padding: 14px 18px;
  max-width: 760px;
  background: #fff3cd;
  border: 2px solid #ffc107;
  border-radius: 10px;
  color: #5f4300;
  font-size: 0.85em;
  text-align: center;
`;

// Onboarding (no-orders-yet) Styled Components
const OnboardingCard = styled.div`
  width: min(100%, 680px);
  margin: 40px auto;
  padding: 32px 36px;
  background: #ffffff;
  border: 2px solid #ffc107;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  color: #1a1a2e;
  text-align: left;
  box-sizing: border-box;
`;

const OnboardingTitle = styled.h2`
  margin: 0 0 8px 0;
  font-size: 1.6em;
  color: #b26a00;
`;

const PracticeStatusCard = styled(OnboardingCard)`
  border-color: #d84315;
  max-width: 680px;
`;

const PracticeStatusTitle = styled(OnboardingTitle)`
  color: #b71c1c;
`;

const OnboardingSubtitle = styled.p`
  margin: 0 0 20px 0;
  color: #555;
  font-size: 1em;
`;

const OnboardingStepList = styled.ol`
  margin: 0 0 24px 0;
  padding-left: 22px;
  color: #333;
  font-size: 1em;
  line-height: 1.55;

  li {
    margin-bottom: 10px;
  }

  strong {
    color: #1a1a2e;
  }
`;

const OnboardingActions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 8px;
`;

const OnboardingCallSlot = styled.div`
  margin: 8px 0 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;

  form {
    width: 100%;
  }

  form > div {
    align-items: center !important;
  }

  button {
    margin-left: auto;
    margin-right: auto;
  }
`;

const OnboardingPrimaryButton = styled.button`
  padding: 12px 22px;
  font-size: 1em;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #007BFF, #0056b3);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.25);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(0, 123, 255, 0.35);
  }

  &:disabled {
    background: #9e9e9e;
    cursor: wait;
    box-shadow: none;
    transform: none;
  }
`;

const OnboardingSecondaryButton = styled.button`
  padding: 12px 22px;
  font-size: 1em;
  font-weight: 500;
  color: #333;
  background: #fff;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #f5f5f5;
    border-color: #ccc;
  }
`;

// Review Modal Styled Components
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 32px;
  width: 90%;
  max-width: 500px;
  max-height: 88vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const ModalTitle = styled.h2`
  margin: 0 0 8px 0;
  color: #1a1a2e;
  font-size: 1.5em;
  font-weight: 600;
`;

const ModalSubtitle = styled.p`
  margin: 0 0 24px 0;
  color: #666;
  font-size: 0.95em;
`;

const ModalTextarea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 16px;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  font-size: 1em;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #007BFF;
    box-shadow: 0 0 0 4px rgba(0, 123, 255, 0.1);
  }

  &::placeholder {
    color: #aaa;
  }
`;

const IssueOptionList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-bottom: 18px;
`;

const IssueOptionButton = styled.button`
  width: 100%;
  padding: 12px 14px;
  border-radius: 8px;
  border: 2px solid ${props => props.$selected ? '#007BFF' : '#e0e0e0'};
  background: ${props => props.$selected ? '#e3f2fd' : '#fff'};
  color: #222;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover {
    border-color: #007BFF;
    background: #f4f9ff;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }
`;

const IssueOptionLabel = styled.div`
  font-size: 0.95em;
  font-weight: 700;
  margin-bottom: 3px;
`;

const IssueOptionDescription = styled.div`
  font-size: 0.78em;
  line-height: 1.35;
  color: #666;
`;

const ModalError = styled.div`
  margin: 12px 0 0 0;
  padding: 10px 12px;
  border: 1px solid #f44336;
  border-radius: 8px;
  color: #8a1f17;
  background: #ffebee;
  font-size: 0.85em;
  line-height: 1.4;
`;

const ModalButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
  justify-content: flex-end;
`;

const ModalButton = styled.button`
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 1em;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  ${props => props.$primary ? `
    background: linear-gradient(135deg, #007BFF, #0056b3);
    color: white;
    border: none;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 123, 255, 0.4);
    }

    &:disabled {
      background: #ccc;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
    }
  ` : `
    background: white;
    color: #666;
    border: 2px solid #e0e0e0;

    &:hover {
      background: #f5f5f5;
      border-color: #ccc;
    }
  `}
`;

const CharCount = styled.span`
  display: block;
  text-align: right;
  margin-top: 8px;
  font-size: 0.85em;
  color: ${props => props.$warning ? '#e74c3c' : '#999'};
`;

const getCorrectionKey = (comparisonResult) => {
  return comparisonResult?.order1Data?.id || comparisonResult?.order1Data?.name || null;
};

const orderNeedsCorrection = (comparisonResult) => {
  if (!comparisonResult) return false;
  if (!comparisonResult.order2Data) return false;

  // Price-only drift is allowed to move forward; only content mismatches
  // from the comparison engine should hold the trainee on this order.
  const unmatchedPenalty = Number(comparisonResult.unmatchedPenalty || 0);
  const missingTraineeRows = comparisonResult.notMatchingInOrder1Data?.length || 0;
  const missingRealRows = comparisonResult.notMatchingInOrder2Data?.length || 0;

  return (
    unmatchedPenalty > 0 ||
    missingTraineeRows > 0 ||
    missingRealRows > 0
  );
};

const loadReportedBugUnlocks = () => {
  try {
    return JSON.parse(sessionStorage.getItem('trainingBugReportUnlocks') || '{}');
  } catch (error) {
    console.error('Failed to read trainingBugReportUnlocks:', error);
    return {};
  }
};


function App() {

  console.log("App() has run");
  const location = useLocation();
  const [comparisonResults, setComparisonResults] = useState([]);
  const [receiptPreviews, setReceiptPreviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSocketConnected, setIsSocketConnected] = useState(false);
  const [recivedComparisonResults, setRecivedComparisonResults] = useState(false);
  const [requestStatuses, setRequestStatuses] = useState([]);
  const [copyStatusMessage, updateCopyStatus] = useState('📸 Copy to Signal');
  const [requireReview, setRequireReview] = useState(Array(comparisonResults.length).fill(false));
  const [reviewNotes, setReviewNotes] = useState(Array(comparisonResults.length).fill('')); // Trainee explanation for review
  const [reviewIssueSelections, setReviewIssueSelections] = useState(Array(comparisonResults.length).fill(null));
  const [isAudioMixer, setIsAudioMixer] = useState(false);
  const [socketErrorMessage, setSocketErrorMessage] = useState('');

  // Review Modal State - v2
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [reviewModalIndex, setReviewModalIndex] = useState(null);
  const [reviewModalNote, setReviewModalNote] = useState('');
  const [reviewModalIssueType, setReviewModalIssueType] = useState('');
  const [reviewModalError, setReviewModalError] = useState('');
  const [reviewModalMode, setReviewModalMode] = useState('review');
  const [reviewModalSubmitting, setReviewModalSubmitting] = useState(false);
  const [reportedBugUnlocks, setReportedBugUnlocks] = useState(loadReportedBugUnlocks);
  const [correctionRetryMessage, setCorrectionRetryMessage] = useState('');
  const [correctionPosOrderKey, setCorrectionPosOrderKey] = useState(null);
  const [correctionRetryAttempt, setCorrectionRetryAttempt] = useState(0);

  const [sessionId, setSessionId] = useState(null);
  const previousResultsRef = useRef([]);
  const activeTrainingCallRef = useRef(false);
  const activeTrainingStartedAtRef = useRef(null);
  const activeTrainingOrderIdRef = useRef(null);
  const activeTrainingMatchKeyRef = useRef(null);
  const [trainingCallActive, setTrainingCallActiveState] = useState(false);

  const setTrainingCallActive = useCallback((isActive) => {
    const nextIsActive = Boolean(isActive);
    setTrainingCallActiveState(nextIsActive);
    if (nextIsActive && !activeTrainingCallRef.current) {
      activeTrainingStartedAtRef.current = Date.now();
    }
    activeTrainingCallRef.current = nextIsActive;
    if (!nextIsActive) {
      activeTrainingStartedAtRef.current = null;
      activeTrainingOrderIdRef.current = null;
      activeTrainingMatchKeyRef.current = null;
    }
  }, []);

  const normalizeShopifyId = useCallback((value) => {
    return String(value ?? '').match(/\d+$/)?.[0] || null;
  }, []);

  const normalizeMatchKey = useCallback((value) => {
    const digits = String(value || '').replace(/\D/g, '');
    return digits || null;
  }, []);

  const setActiveTrainingOrder = useCallback((orderData) => {
    if (!orderData) {
      activeTrainingOrderIdRef.current = null;
      activeTrainingMatchKeyRef.current = null;
      return;
    }

    activeTrainingOrderIdRef.current = normalizeShopifyId(orderData.id || orderData.legacyResourceId);
    activeTrainingMatchKeyRef.current = normalizeMatchKey(
      orderData.shipping_address?.last_name || orderData.shippingAddress?.lastName
    );
  }, [normalizeMatchKey, normalizeShopifyId]);

  // Onboarding state for brand-new trainee accounts that have no orders yet.
  // Backend signals this with { noOrdersYet: true } in the comparisonResult payload.
  const [needsFirstOrder, setNeedsFirstOrder] = useState(false);
  const [onboardingInfo, setOnboardingInfo] = useState(null); // { customerId, customerTags, restaurantName }


  const simplifyingOrderData = (order, notMatchingData) => {
    if (!order) {
      console.log(`no data for rawOrder`);
      return { order: [], notMatchingData: [] };
    }
  

    const simplifiedOrder = {
      id: Number(order.legacyResourceId),
      name: order.name,
      created_at: order.createdAt,
      note: order.note,
      customer: {
        id: Number(order.customer.legacyResourceId),
        first_name: order.customer.firstName,
        last_name: order.customer.lastName || '',
        email: order.customer.email || '',
        default_address:{
          address1: order.customer.defaultAddress.address1,
          address2: order.customer.defaultAddress.address2,
          city: order.customer.defaultAddress.city,
          province_code: order.customer.defaultAddress.provinceCode,
          zip: order.customer.defaultAddress.zip,
          phone: order.customer.defaultAddress.phone
        }
      },
      shipping_address: order.shippingAddress 
      ? { last_name: order.shippingAddress.lastName } 
      : {},
      line_items: order.lineItems.edges.map(edge => {
        const isNotMatching = notMatchingData.some(item => item.node.id === edge.node.id);

        return {
          price: edge.node.originalUnitPriceSet.shopMoney.amount,
          quantity: edge.node.quantity,
          properties: edge.node.customAttributes.map(attribute => ({ name: attribute.key, value: attribute.value })),
          title: edge.node.title,
          variant_title: edge.node.variant ? (edge.node.variant.title === 'Default Title' ? null : edge.node.variant.title) : null,
          sku: edge.node.variant ? edge.node.variant.sku : null,
          isNotMatching: isNotMatching
        };
      }),
      subtotal_price: order.subtotalPriceSet.shopMoney.amount,
      total_tax: order.totalTaxSet.shopMoney.amount,
      total_price: order.totalPriceSet.shopMoney.amount,
      metafield: order.metafield
    };

    return { simplifiedOrder, notMatchingData };

  }  

  function sortLineItems(order) {
    if (!order || !order.line_items) {
      console.log("order.line_items is undefined");
      return order;
    }
    let sortedItems = [];
    let parentItems = {};
    let childItems = {};
  
    order.line_items.forEach(item => {
      let orderGroup = item.properties.find(prop => prop.name === '_io_order_group')?.value;
      let parentGroup = item.properties.find(prop => prop.name === '_io_parent_order_group')?.value;
  
      if (orderGroup && parentGroup) {
        throw new Error("Line item cannot have both _io_order_group and _io_parent_order_group");
      }
  
      if (orderGroup) {
        // Check if there are any child items waiting for this parent
        if (childItems[orderGroup]) {
          sortedItems.push(item, ...childItems[orderGroup]);
          delete childItems[orderGroup];
        } else {
          sortedItems.push(item);
        }
        parentItems[orderGroup] = item;
      } else if (parentGroup) {
        // Check if the parent item has already been added to sortedItems
        if (parentItems[parentGroup]) {
          // Insert this child item right after its parent
          let parentIndex = sortedItems.indexOf(parentItems[parentGroup]);
          sortedItems.splice(parentIndex + 1, 0, item);
        } else {
          // The parent item has not been encountered yet, so we add this to childItems
          if (!childItems[parentGroup]) childItems[parentGroup] = [];
          childItems[parentGroup].push(item);
        }
      } else {
        sortedItems.push(item);
      }
    });
  
    // Check if there are any remaining childItems that weren't included
    for (let group in childItems) {
      sortedItems.push(...childItems[group]);
    }
  
    order.line_items = sortedItems;
    return order;
  }
  
  const socket = useRef(null);


  useEffect(() => {
    try {
      sessionStorage.setItem('trainingBugReportUnlocks', JSON.stringify(reportedBugUnlocks));
    } catch (error) {
      console.error('Failed to save trainingBugReportUnlocks:', error);
    }
  }, [reportedBugUnlocks]);


  useEffect(() => {
    setRequestStatuses(Array(comparisonResults.length).fill('idle'));
  }, [comparisonResults]);  

  useEffect(() => {
    const prevResults = previousResultsRef.current;
    const prevLength = prevResults.length;
    const nextLength = comparisonResults.length;

    if (prevLength !== nextLength) {
      const diff = nextLength - prevLength;
      const nextFirstId = comparisonResults[0]?.order1Data?.id;
      const nextLastId = comparisonResults[nextLength - 1]?.order1Data?.id;
      const prevFirstId = prevResults[0]?.order1Data?.id;
      const prevLastId = prevResults[prevLength - 1]?.order1Data?.id;
      const isPrepend = prevLength > 0 && nextLastId === prevLastId && nextFirstId !== prevFirstId;
      const isAppend = prevLength > 0 && nextFirstId === prevFirstId && nextLastId !== prevLastId;

      const adjustArray = (prevArray, defaultValue) => {
        if (nextLength < prevArray.length) {
          return prevArray.slice(0, nextLength);
        }
        if (prevLength === 0) {
          return Array(nextLength).fill(defaultValue);
        }
        if (isPrepend && diff > 0) {
          return [...Array(diff).fill(defaultValue), ...prevArray];
        }
        if (isAppend && diff > 0) {
          return [...prevArray, ...Array(diff).fill(defaultValue)];
        }
        const nextArray = prevArray.slice(0, nextLength);
        while (nextArray.length < nextLength) {
          nextArray.push(defaultValue);
        }
        return nextArray;
      };

      setRequireReview((prev) => adjustArray(prev, false));
      setReviewNotes((prev) => adjustArray(prev, ''));
    }

    previousResultsRef.current = comparisonResults;
  }, [comparisonResults]);




  useEffect(() => {
    // console.log('useEffect - location', location);



    // Extract session_id from URL
    const params = new URLSearchParams(location.search);
    setSessionId(params.get('session_id'));
  }, [location]);
  
  
  useEffect(() => {

        // Initialize socket inside useEffect
      socket.current = io('https://api.pacificpearltraining.site/comparison');
      console.log('sessionId', sessionId, typeof sessionId);
    
    // Send session_id to backend for verification
    if (sessionId) {
      axios.get('https://api.pacificpearltraining.site/verify-session', {
        params: {
          session_id: sessionId
        }
      })
      .then(response => {
        // Handle response
        if (response.data.success) {
          console.log('Session ID is valid');
          setSocketErrorMessage('');
          // Store session ID in local storage
          localStorage.setItem('sessionId', sessionId);
          


          const sendSessionId = () => {
            setIsSocketConnected(true);
            socket.current.emit('message', JSON.stringify({ type: 'session_id', value: sessionId, sessionId:sessionId }));
          };

          socket.current.on('connect', sendSessionId);
          if (socket.current.connected) {
            sendSessionId();
          }


          socket.current.on('connect_error', (error) => {
            console.error('Connection Error:', error);
            setSocketErrorMessage('Practice Calls could not connect. Please refresh once, or use Feedback / Help if it still does not work.');
            setLoading(false);
          });
      
          socket.current.on('connect_timeout', () => {
            console.error('Connection Timeout');
          });

          socket.current.on('comparisonResult', (event) => {
            setSocketErrorMessage('');
            // Handle incoming comparison result
            const parsedEvent = JSON.parse(event);
            const activeTrainingOrderId = activeTrainingOrderIdRef.current;
            const activeTrainingStartedAt = activeTrainingStartedAtRef.current;

            if (activeTrainingCallRef.current && parsedEvent) {
              const incomingRealOrderId = normalizeShopifyId(
                parsedEvent.order2Data?.legacyResourceId || parsedEvent.order2Data?.id
              );
              const incomingTraineeCreatedAt = parsedEvent.order1Data?.createdAt
                ? Date.parse(parsedEvent.order1Data.createdAt)
                : null;
              const isRecentTraineeOrder =
                Number.isFinite(incomingTraineeCreatedAt) &&
                activeTrainingStartedAt &&
                incomingTraineeCreatedAt >= activeTrainingStartedAt - 60000;
              const incomingMatchKey = normalizeMatchKey(
                parsedEvent.order1Data?.shippingAddress?.lastName ||
                parsedEvent.order1Data?.shipping_address?.last_name
              );
              const activeMatchKey = activeTrainingMatchKeyRef.current;
              const matchKeyFits =
                !activeMatchKey ||
                !incomingMatchKey ||
                activeMatchKey === incomingMatchKey;
              const isActiveRealOrderComparison =
                activeTrainingOrderId &&
                incomingRealOrderId === activeTrainingOrderId &&
                isRecentTraineeOrder;
              const isCurrentNoComparisonResult =
                parsedEvent.noComparisonAvailable &&
                parsedEvent.order1Data &&
                !parsedEvent.order2Data &&
                isRecentTraineeOrder &&
                matchKeyFits;

              if (!isActiveRealOrderComparison && !isCurrentNoComparisonResult) {
                console.log('Ignoring stale comparison result while a training call is active', {
                  activeTrainingOrderId,
                  incomingRealOrderId,
                  incomingTraineeOrderId: normalizeShopifyId(
                    parsedEvent.order1Data?.legacyResourceId || parsedEvent.order1Data?.id
                  ),
                  incomingTraineeCreatedAt: parsedEvent.order1Data?.createdAt || null,
                });
                setLoading(false);
                return;
              }
            }

            // New trainee account, or a trainee order that has no real order
            // available to compare against. In both cases, stop before the
            // correction flow so a first/no-comparison order is not marked wrong.
            if (parsedEvent && (parsedEvent.noOrdersYet || parsedEvent.noComparisonAvailable || !parsedEvent.order1Data)) {
              const shouldKeepActiveCall =
                activeTrainingCallRef.current &&
                (parsedEvent.noOrdersYet || (!parsedEvent.order1Data && !parsedEvent.accountSetupIssue));

              if (shouldKeepActiveCall) {
                console.log('Ignoring stale empty comparison result while a training call is active', parsedEvent);
                setLoading(false);
                return;
              }

              setTrainingCallActive(false);
              console.log('No comparable order for this trainee - showing onboarding/no-comparison instructions', parsedEvent);
              setNeedsFirstOrder(true);
              setOnboardingInfo({
                customerId: parsedEvent.customerId,
                customerTags: parsedEvent.customerTags,
                restaurantName: parsedEvent.restaurantName || null,
                noComparisonAvailable: Boolean(parsedEvent.noComparisonAvailable),
                accountSetupIssue: Boolean(parsedEvent.accountSetupIssue),
                setupIssueType: parsedEvent.setupIssueType || null,
                setupIssueTitle: parsedEvent.setupIssueTitle || null,
                setupIssueMessage: parsedEvent.setupIssueMessage || null,
                hasPracticeOrder: Boolean(parsedEvent.order1Data),
              });
              setComparisonResults([]);
              setCorrectionRetryMessage('');
              setCorrectionPosOrderKey(null);
              setLoading(false);
              setRecivedComparisonResults(true);
              return;
            }
            // We have real comparison data - make sure onboarding is cleared
            setTrainingCallActive(false);
            setNeedsFirstOrder(false);
            setOnboardingInfo(null);

            const processedOrder1 = simplifyingOrderData(parsedEvent.order1Data, parsedEvent.notMatchingInOrder1Data);
            const processedOrder2 = simplifyingOrderData(parsedEvent.order2Data, parsedEvent.notMatchingInOrder2Data);
            // console.log('processedOrder1',processedOrder1);
            // console.log('processedOrder2',processedOrder2);
            console.log('parsedEvent.GPTCompletionData',parsedEvent.GPTCompletionData);
            const sortedOrder1 = sortLineItems(processedOrder1.simplifiedOrder);
            const sortedOrder2 = sortLineItems(processedOrder2.simplifiedOrder);

            const processedComparisonResult = {
              order1Data: sortedOrder1,
              order2Data: sortedOrder2,
              notMatchingInOrder1Data: processedOrder1.notMatchingData,
              notMatchingInOrder2Data: processedOrder2.notMatchingData,
              customerId: parsedEvent.customerId,
              customerTags: parsedEvent.customerTags,
              restaurantName: parsedEvent.restaurantName || null,
              score: parsedEvent.score,
              unmatchedPenalty: parsedEvent.unmatchedPenalty,
              timePenalty: parsedEvent.timePenalty,
              GPTCompletionData:parsedEvent.GPTCompletionData,
              realOrderReceiptUrl: parsedEvent.realOrderReceiptUrl || null,
              traineeOrderReceiptUrl: parsedEvent.traineeOrderReceiptUrl || null,
            };
          

            setComparisonResults(prevResults => {
              // Get the createdAt date from the new result
              const newResultDate = new Date(processedComparisonResult.order1Data.created_at);
            
              // Get the createdAt date from the last result
              const lastResultDate = prevResults.length > 0 ? new Date(prevResults[0].order1Data.created_at) : new Date(0);
            
              // If the new result is more recent, insert it at the beginning
              if (newResultDate > lastResultDate) {
                console.log("add processedComparisonResult to the beginning of ComparisonResults:",[processedComparisonResult, ...prevResults]);
                return [processedComparisonResult, ...prevResults];
              } else {
                // Else, append it at the end
                console.log("add processedComparisonResult to the end of ComparisonResults:",[...prevResults, processedComparisonResult]);
                return [...prevResults, processedComparisonResult];
              }

            });

            setLoading(false);
            console.log('recived compareisonResult:');
            console.dir(parsedEvent,{ depth: null });
            setRecivedComparisonResults(true);
          });

          socket.current.on('error', (error) => {
            console.error('Socket.IO error:', error);
            const message = typeof error === 'string'
              ? error
              : error?.message || 'Practice Calls could not connect.';
            setSocketErrorMessage(message);
            setLoading(false);
            setTrainingCallActive(false);
            setRecivedComparisonResults(true);
          });

          socket.current.on('receiptPreview', (event) => {
            try {
              const parsed = JSON.parse(event);
              console.log('Received receiptPreview for order:', parsed.orderName, 'PrintNode Job ID:', parsed.printJobId);
              setReceiptPreviews(prev => [parsed, ...prev]);
            } catch (err) {
              console.error('Error parsing receiptPreview:', err);
            }
          });

          return () => {
            console.log('Close Socket.IO connection when component unmounts');
            socket.current.disconnect();
          };




        } else {
          console.log('Invalid session ID');
          setSocketErrorMessage('This Practice Calls session is no longer valid. Please go back to the trainee page and start again.');
        }
      })
      .catch(error => {
        // Handle error
        console.error('Error:', error);
        setSocketErrorMessage('Practice Calls could not verify this session. Please go back to the trainee page and start again.');
        setLoading(false);
      });
    }

    // Cleanup function
    return () => {
      if (socket.current) {
          // Disconnect from the socket
          socket.current.disconnect();

          // Set the current reference to null
          socket.current = null;
      }
    }
  }, [sessionId, setTrainingCallActive, normalizeMatchKey, normalizeShopifyId]);

  const loadMoreOrders = useCallback(() => {
    const latestResult = comparisonResults[0];
    const latestCorrectionKey = getCorrectionKey(latestResult);
    const correctionLocked = orderNeedsCorrection(latestResult) && !reportedBugUnlocks[latestCorrectionKey];

    if (correctionLocked) {
      setCorrectionRetryMessage('Finish this correction or report a system bug before loading another order.');
      return;
    }

    setLoading(true); // Start loading when the request begins.
    const lastOrderId = Number(comparisonResults[comparisonResults.length - 1].order1Data.id);
    const lastOrderData = {
      type: 'next_order', 
      lastOrderId: lastOrderId,
      customerId: comparisonResults[comparisonResults.length - 1].customerId,
      customerTags: comparisonResults[comparisonResults.length - 1].customerTags,
      sessionId: sessionId
    }
    console.log("loadMoreOrders Button - lastOrderData",lastOrderData);
    socket.current.emit('message', JSON.stringify(lastOrderData));
  }, [comparisonResults, reportedBugUnlocks, sessionId]); // dependencies
  


  if (!comparisonResults) {
    return (
      <div>Waiting for data...</div>
    );
  }
  



  const captureScreenAndEmail = async (index,order2Data,order1Data,reviewNoteOverride,reviewIssueOptionOverride) => {
    console.log('captureScreenAndEmail called with index:', index); // Log index
    console.log('Current request statuses:', requestStatuses); // Log current statuses
    // Change the status to 'sending' for the clicked button
    const newStatuses = [...requestStatuses];
    newStatuses[index] = 'sending';
    setRequestStatuses(newStatuses);

    console.log('Updated request statuses:', newStatuses); // Log updated statuses

    if (reviewNoteOverride != null) {
      return await sendScreenCapture(
        null,
        index,
        order2Data,
        order1Data,
        reviewNoteOverride,
        reviewIssueOptionOverride
      );
    }

    // Concatenate the index with the ID to target the specific element
    const input = document.getElementById(`orderCapture-${index}`);

    try {
      const canvas = await html2canvas(input);
      const imgData = canvas.toDataURL('image/png');

      // Split the data URL at the comma and get the base64 data
      const base64Data = imgData.split(",")[1];

      // Send the screenshot to the backend with trainee info
      return await sendScreenCapture(base64Data,index,order2Data,order1Data,reviewNoteOverride,reviewIssueOptionOverride);
    } catch (error) {
      console.error('Failed to capture screen for email:', error);
      const failedStatuses = [...requestStatuses];
      failedStatuses[index] = 'idle';
      setRequestStatuses(failedStatuses);
      return { ok: false, message: 'Could not capture the review screenshot. Please try again.' };
    }
  }


  const captureScreenAndCopy = async (index, order2Data, order1Data) => {
    const input = document.getElementById(`orderCapture-${index}`);
    console.log('captureScreenAndCopy-order2Data.id',order2Data);
    try {
      const canvas = await html2canvas(input);
      canvas.toBlob(async (blob) => {
        const item = new ClipboardItem({ 'image/png': blob });
        await navigator.clipboard.write([item]);
        updateCopyStatus('🎉 Copied, Now Paste in Your Signal Group'); // Success message
        setTimeout(() => updateCopyStatus('📸 Copy to Signal'), 5000); // Reset the text after 5 seconds
      });
    } catch (err) {
      console.error('Failed to copy image: ', err); // Error logging
      updateCopyStatus('😢 Oops! Something Went Wrong!'); // Failure message
      setTimeout(() => updateCopyStatus('📸 Copy to Signal'), 5000); // Reset the text after 5 seconds
    }

      // Review reports are now validated and saved when the trainee submits the
      // modal, so copying the screenshot should not create a duplicate report.
  }
  
  

  const sendScreenCapture = async (imgData,index,order2Data,order1Data,reviewNoteOverride,reviewIssueOptionOverride) => {
    console.log('sendScreenCapture called with index:', index); // Log index

    // Get trainee info from order1Data (trainee's order)
    const traineeInfo = order1Data?.customer ? {
      firstName: order1Data.customer.first_name || '',
      lastName: order1Data.customer.last_name || '',
      email: order1Data.customer.email || '',
      customerId: order1Data.customer.id
    } : null;

    const issueOption = reviewIssueOptionOverride || reviewIssueSelections[index] || null;
    const payload = {
      orgiinalOrderId: order2Data?.id || order1Data?.id || order1Data?.name,
      traineeInfo: traineeInfo,
      reviewNote: reviewNoteOverride ?? reviewNotes[index] ?? '',
      originalOrder: order2Data,
      traineeOrder: order1Data,
      customerTags: comparisonResults[index]?.customerTags || [],
      issueOption,
      issueType: issueOption?.id || '',
      issueLabel: issueOption?.label || '',
      trainingTranscript: comparisonResults[index]?.GPTCompletionData || '',
      score: comparisonResults[index]?.score,
      unmatchedPenalty: comparisonResults[index]?.unmatchedPenalty,
      timePenalty: comparisonResults[index]?.timePenalty
    };

    if (imgData) {
      payload.imgData = imgData;
    }

    try {
      const response = await fetch('https://api.pacificpearltraining.site/emailScreenShot', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
  
      if (response.ok) {
        const payload = await response.json().catch(() => ({}));
        console.log('Review/screenshot request saved successfully');
        // Change the status to 'sent' for the clicked button
        const newStatuses = [...requestStatuses];
        newStatuses[index] = 'sent';
        setRequestStatuses(newStatuses);
        return { ok: true, payload };
      } else {
        const payload = await response.json().catch(() => ({}));
        const message = payload?.message || 'Review could not be saved. Please try again or ask a trainer.';
        console.log('Email/review request failed:', message);
        const failedStatuses = [...requestStatuses];
        failedStatuses[index] = 'idle';
        setRequestStatuses(failedStatuses);
        setReviewModalError(message);
        return { ok: false, payload, message };
      }
    } catch (error) {
      console.error('Error:', error);
      const failedStatuses = [...requestStatuses];
      failedStatuses[index] = 'idle';
      setRequestStatuses(failedStatuses);
      const message = 'Network error while saving the review. Please try again or ask a trainer.';
      setReviewModalError(message);
      return { ok: false, message };
    }
  }
  

  const handleReview = (index) => {
    console.log('[ReviewModal v2] handleReview called for index:', index, 'requireReview:', requireReview[index]);
    if (!requireReview[index]) {
      // Requesting a review - open modal
      console.log('[ReviewModal v2] Opening modal...');
      setReviewModalMode('review');
      setReviewModalIndex(index);
      setReviewModalNote('');
      setReviewModalIssueType(reviewIssueSelections[index]?.id || '');
      setReviewModalError('');
      setShowReviewModal(true);
    } else {
      // Removing review request
      const newRequireReview = [...requireReview];
      const newReviewNotes = [...reviewNotes];
      const newIssueSelections = [...reviewIssueSelections];
      newReviewNotes[index] = '';
      newIssueSelections[index] = null;
      newRequireReview[index] = false;
      setReviewNotes(newReviewNotes);
      setReviewIssueSelections(newIssueSelections);
      setRequireReview(newRequireReview);
    }
  }

  const handleBugReport = (index) => {
    setReviewModalMode('bugReport');
    setReviewModalIndex(index);
    setReviewModalNote(reviewNotes[index] || '');
    setReviewModalIssueType(reviewIssueSelections[index]?.id || '');
    setReviewModalError('');
    setShowReviewModal(true);
  }

  const handleReviewModalSubmit = async () => {
    if (reviewModalIndex === null) {
      setShowReviewModal(false);
      setReviewModalIndex(null);
      setReviewModalNote('');
      setReviewModalIssueType('');
      setReviewModalError('');
      return;
    }
    const selectedIssue = REVIEW_ISSUE_OPTIONS.find(option => option.id === reviewModalIssueType);
    if (!selectedIssue) {
      setReviewModalError('Choose the issue type that best matches the problem.');
      return;
    }
    if (reviewModalNote.trim() === '') {
      setReviewModalError('Write one clear sentence explaining the problem.');
      return; // Don't submit empty notes
    }

    const comparisonResult = comparisonResults[reviewModalIndex];
    setReviewModalSubmitting(true);
    setReviewModalError('');
    const result = await captureScreenAndEmail(
      reviewModalIndex,
      comparisonResult?.order2Data,
      comparisonResult?.order1Data,
      reviewModalNote.trim(),
      selectedIssue
    );
    setReviewModalSubmitting(false);

    if (!result?.ok) {
      setCorrectionRetryMessage(result?.message || 'Review report could not be saved. Please try again.');
      return;
    }

    const newRequireReview = [...requireReview];
    const newReviewNotes = [...reviewNotes];
    const newIssueSelections = [...reviewIssueSelections];
    newReviewNotes[reviewModalIndex] = reviewModalNote.trim();
    newIssueSelections[reviewModalIndex] = selectedIssue;
    newRequireReview[reviewModalIndex] = true;

    setReviewNotes(newReviewNotes);
    setReviewIssueSelections(newIssueSelections);
    setRequireReview(newRequireReview);

    if (reviewModalMode === 'bugReport') {
      const correctionKey = getCorrectionKey(comparisonResult);
      if (correctionKey) {
        setReportedBugUnlocks(prev => ({ ...prev, [correctionKey]: true }));
      }
      setCorrectionRetryMessage('Report saved for trainer review. You can continue to another order.');
    }

    setShowReviewModal(false);
    setReviewModalIndex(null);
    setReviewModalNote('');
    setReviewModalIssueType('');
    setReviewModalError('');
  }

  const handleReviewModalCancel = () => {
    if (reviewModalSubmitting) return;
    setShowReviewModal(false);
    setReviewModalIndex(null);
    setReviewModalNote('');
    setReviewModalIssueType('');
    setReviewModalError('');
  }

  const handleFixThisOrder = (comparisonResult) => {
    const correctionKey = getCorrectionKey(comparisonResult);

    setCorrectionPosOrderKey(correctionKey);
    setCorrectionRetryAttempt(prev => prev + 1);
    setCorrectionRetryMessage('Replay the customer call, then enter the order again in the normal POS.');
  }

  // Function to toggle testing state
  const toggleAudioMixer = () => {
    setIsAudioMixer(!isAudioMixer);
  };
  
  const latestComparisonResult = comparisonResults[0] || null;
  const activeCorrectionKey = getCorrectionKey(latestComparisonResult);
  const activeCorrectionLock = orderNeedsCorrection(latestComparisonResult) && !reportedBugUnlocks[activeCorrectionKey];
  const showTopCorrectionPos = activeCorrectionLock && correctionPosOrderKey === activeCorrectionKey;
  const orderAudioComparisonResults = comparisonResults.length > 0
    ? comparisonResults
    : onboardingInfo?.customerId
      ? [{
          customerId: onboardingInfo.customerId,
          customerTags: onboardingInfo.customerTags || [],
          restaurantName: onboardingInfo.restaurantName || null,
        }]
	      : [];
	  const isAccountSetupIssue = Boolean(onboardingInfo?.accountSetupIssue);
	  const isNonTrainingAccount = onboardingInfo?.setupIssueType === 'non_training_account'
	    || onboardingInfo?.setupIssueType === 'missing_trainee_tag';
	  const accountSetupTitle = onboardingInfo?.setupIssueTitle
	    || (isNonTrainingAccount ? 'Training account required' : 'Account setup needed');
	  const canUseTrainingControls = !isAccountSetupIssue;
	  const canUseAudioMixer = true;
	  const canShowOrderAudio = isSocketConnected
	    && canUseTrainingControls
	    && orderAudioComparisonResults.length > 0
	    && (!activeCorrectionLock || showTopCorrectionPos);






  return (
    
    <ShopifyProvider
    storeDomain={process.env.REACT_APP_PUBLIC_STORE_DOMAIN}
    storefrontToken={process.env.REACT_APP_PUBLIC_STOREFRONT_API_TOKEN}
    storefrontApiVersion="2023-10"
    countryIsoCode="US"
    languageIsoCode="EN"
    >
      <CartProvider
      onLineAdd={() => {
        console.log('onLineAdd - a line is being added');
      }}
      onLineAddComplete={() => {
        console.log('onLineAddComplete - a line has been added');
      }}
      >
    
        <div className="App">

          
        
          
		            <Routes>
		              <Route path="/" element={
		                isAudioMixer && canUseAudioMixer ? <AudioMixer toggleAudioMixer={toggleAudioMixer} isAudioMixer={isAudioMixer} restaurantName={onboardingInfo?.restaurantName || comparisonResults[0]?.restaurantName || ''} /> : (

		                  <>
		                    {canUseAudioMixer && (
		                      <button onClick={toggleAudioMixer} style={{ padding: '8px 16px', background: '#1565c0', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9em' }}>
		                        Broadcast Audio to Restaurant
		                      </button>
	                    )}

	                    <header className="App-header">
	                    <img src={logo} className="App-logo" alt="Pacific Pearl" />
                        <LandingReturnButton
                          type="button"
                          onClick={() => window.location.assign('/trainee')}
                        >
                          Back to Pacific Pearl training page
                        </LandingReturnButton>
                        {canShowOrderAudio && !needsFirstOrder && (
                          <OrderToAudio
                            socket={socket}
                            comparisonResults={orderAudioComparisonResults}
                            recivedComparisonResults={recivedComparisonResults}
                            setRecivedComparisonResults={setRecivedComparisonResults}
                            sessionId={sessionId}
                            retryOrderId={showTopCorrectionPos ? latestComparisonResult?.order2Data?.id : null}
                            retryCustomerId={showTopCorrectionPos ? latestComparisonResult?.customerId : null}
                            retryCustomerTags={showTopCorrectionPos ? latestComparisonResult?.customerTags : null}
                            autoStartKey={showTopCorrectionPos ? `${activeCorrectionKey}:${correctionRetryAttempt}` : null}
	                            correctionMode={showTopCorrectionPos}
	                            onTrainingCallActiveChange={setTrainingCallActive}
	                            onActiveTrainingOrderChange={setActiveTrainingOrder}
	                            buildPosUrl={buildTraineePosUrl}
	                          />
                        )}
                        {activeCorrectionLock && latestComparisonResult && !showTopCorrectionPos && (
                          <CorrectionGate $top>
                            <CorrectionTitle>Correction required before continuing</CorrectionTitle>
                            <CorrectionText>
                              Retry this same order until it is correct. If the POS or training data is wrong, send a system bug report with a note first.
                            </CorrectionText>
                            <CorrectionActions>
                              <CorrectionButton
                                onClick={() => handleFixThisOrder(latestComparisonResult)}
                                disabled={!latestComparisonResult.order2Data}
                              >
                                Fix This Order
                              </CorrectionButton>
                              <CorrectionButton
                                $secondary
                                onClick={() => handleBugReport(0)}
                                disabled={requestStatuses[0] === 'sending'}
                              >
                                Report System Bug
                              </CorrectionButton>
                            </CorrectionActions>
                          </CorrectionGate>
                        )}
                        {activeCorrectionLock && latestComparisonResult && showTopCorrectionPos && (
                          <CorrectionGate $top>
                            <CorrectionTitle>Correction in progress</CorrectionTitle>
                            <CorrectionText>
                              Replay the customer call, then enter the order again in the POS. The next submitted order will be checked against this same real order.
                            </CorrectionText>
                            {correctionRetryMessage && (
                              <CorrectionStatus>{correctionRetryMessage}</CorrectionStatus>
                            )}
                          </CorrectionGate>
                        )}
	                        {socketErrorMessage ? (
	                          <PracticeStatusCard>
	                            <PracticeStatusTitle>Practice Calls could not start</PracticeStatusTitle>
	                            <OnboardingSubtitle>
	                              {socketErrorMessage}
	                            </OnboardingSubtitle>
	                            <OnboardingActions>
	                              <OnboardingSecondaryButton onClick={() => window.location.reload()}>
	                                Try again
	                              </OnboardingSecondaryButton>
	                              <OnboardingSecondaryButton onClick={() => window.location.assign('/trainee')}>
	                                Back to training page
	                              </OnboardingSecondaryButton>
	                            </OnboardingActions>
	                          </PracticeStatusCard>
	                        ) : needsFirstOrder && comparisonResults.length === 0 ? (
	                          <OnboardingCard>
	                            <OnboardingTitle>
	                              {trainingCallActive
	                                ? 'Training call in progress'
	                                : onboardingInfo?.accountSetupIssue
	                                ? accountSetupTitle
	                                : onboardingInfo?.noComparisonAvailable
	                                  ? 'No comparison order available yet'
	                                  : 'Ready for your first practice order'}
                            </OnboardingTitle>
                            <OnboardingSubtitle>
                              {trainingCallActive ? (
                                <>
                                  Listen to the customer call, enter the order in the POS, then refresh comparisons
                                  after the order is submitted.
                                </>
                              ) : onboardingInfo?.accountSetupIssue ? (
                                <>
                                  {onboardingInfo.setupIssueMessage || 'This account needs a Shopify tag update before Practice Calls can compare training orders.'}
                                </>
                              ) : onboardingInfo?.noComparisonAvailable ? (
                                <>
                                  This practice order does not have a matching real order to compare against, so it is
                                  not a correction failure. You can continue with another training call for{' '}
                                  <strong>
                                    {onboardingInfo && onboardingInfo.restaurantName
                                      ? onboardingInfo.restaurantName
                                      : 'your restaurant'}
                                  </strong>
                                  .
                                </>
                              ) : (
                                <>
                                  No starter order is needed. Start a training call for{' '}
                                  <strong>
                                    {onboardingInfo && onboardingInfo.restaurantName
                                      ? onboardingInfo.restaurantName
                                      : 'your restaurant'}
                                  </strong>
                                  , enter it in the POS, and Practice Calls will show the comparison after the order
                                  is created.
                                </>
                              )}
                            </OnboardingSubtitle>
                            {!isAccountSetupIssue && (
                              <OnboardingCallSlot>
                                {canShowOrderAudio ? (
                                  <OrderToAudio
                                    socket={socket}
                                    comparisonResults={orderAudioComparisonResults}
                                    recivedComparisonResults={recivedComparisonResults}
                                    setRecivedComparisonResults={setRecivedComparisonResults}
	                                    sessionId={sessionId}
	                                    onTrainingCallActiveChange={setTrainingCallActive}
	                                    onActiveTrainingOrderChange={setActiveTrainingOrder}
	                                    buildPosUrl={buildTraineePosUrl}
	                                    buttonLabel={onboardingInfo?.noComparisonAvailable
                                      ? 'Receive Another Training Customer Call'
                                      : 'Receive First Training Customer Call'}
                                  />
                                ) : (
                                  <OnboardingPrimaryButton disabled>
                                    Preparing training call...
                                  </OnboardingPrimaryButton>
                                )}
                              </OnboardingCallSlot>
                            )}
	                            {!onboardingInfo?.noComparisonAvailable && !isAccountSetupIssue && (
	                              <OnboardingStepList>
                                <li>
                                  Press <strong>Receive First Training Customer Call</strong>.
                                </li>
                                <li>
                                  Open the <strong>POS</strong> and create the practice order from that call.
                                </li>
                                <li>
                                  Create the order from the call. The comparison will show here when the order is done.
                                </li>
                              </OnboardingStepList>
                            )}
	                            {!isAccountSetupIssue && (
	                              <OnboardingActions>
	                                <OnboardingSecondaryButton onClick={() => window.location.reload()}>
	                                  Refresh comparisons
	                                </OnboardingSecondaryButton>
	                              </OnboardingActions>
	                            )}
                          </OnboardingCard>
                        ) : comparisonResults.length > 0 ? (
                          <div className="parentContainer">
                            <h2>Compare Orders:</h2>
                            {
                            comparisonResults.map((comparisonResult, index) => {
                              const { order1Data, order2Data, score, timePenalty, unmatchedPenalty, GPTCompletionData} = comparisonResult;
                              const isLatestLockedOrder = activeCorrectionLock && index === 0 && getCorrectionKey(comparisonResult) === activeCorrectionKey;
                              // const buttonText = requestStatuses[index] === 'idle' ? 'Request A Review'
                              // : requestStatuses[index] === 'sending' ? 'Sending Request...'
                              // : 'Request Sent';
                              return (
                                
                                order1Data && (
                                  
                                <CoolBorder key={index} $border={requireReview[index]}>

                                  <div key={index} id={`orderCapture-${index}`}>
                                  {requireReview[index] && <ReviewRequest>Requested Review</ReviewRequest>}
                                  {requireReview[index] && order1Data.customer && (
                                    <TraineeInfoContainer>
                                      <TraineeInfoText>👤 {order1Data.customer.first_name} {order1Data.customer.last_name}</TraineeInfoText>
                                      <TraineeInfoText>✉️ {order1Data.customer.email}</TraineeInfoText>
                                    </TraineeInfoContainer>
                                  )}
                                  {requireReview[index] && reviewNotes[index] && (
                                    <ReviewNoteContainer>
                                      <ReviewNoteTitle>📝 TRAINEE REVIEW NOTE:</ReviewNoteTitle>
                                      <ReviewNoteText>{reviewNotes[index]}</ReviewNoteText>
                                    </ReviewNoteContainer>
                                  )}
                                    <div className="tableContainer" style={requireReview[index] ? {border: '1px solid red'} : {}}>
                                      {order1Data && <OrderTableStyled><OrderTable orderData={order1Data} tableTitle="Your Order" realOrderData={order2Data} /></OrderTableStyled>}
                                      {order2Data && <OrderTableStyled><OrderTable orderData={order2Data} tableTitle="Real Order" /></OrderTableStyled>}
                                    </div>
                                    {GPTCompletionData && (
                                      <TranscriptContainer>
                                        <p style={{ color: '#d84315', fontSize: '16px' }}>🎧 What The Trainee Heard:</p>
                                        <p style={{ color: '#333', fontStyle: 'italic' }}>"{GPTCompletionData}"</p>
                                      </TranscriptContainer>
                                    )}
                                    
                                    {(order1Data || order2Data) && (
                                      <OrderTotalsContainer>
                                        {order1Data && (
                                          <OrderTotalBox $isTrainee>
                                            <h4>Your Order Total</h4>
                                            {order1Data.subtotal_price != null && <p>Subtotal: ${parseFloat(order1Data.subtotal_price).toFixed(2)}</p>}
                                            {order1Data.total_tax != null && parseFloat(order1Data.total_tax) > 0 && <p>Tax: ${parseFloat(order1Data.total_tax).toFixed(2)}</p>}
                                            {order1Data.total_price != null && <p className="total-amount">Total: ${parseFloat(order1Data.total_price).toFixed(2)}</p>}
                                          </OrderTotalBox>
                                        )}
                                        {order2Data && (
                                          <OrderTotalBox>
                                            <h4>Real Order Total</h4>
                                            {order2Data.subtotal_price != null && <p>Subtotal: ${parseFloat(order2Data.subtotal_price).toFixed(2)}</p>}
                                            {order2Data.total_tax != null && parseFloat(order2Data.total_tax) > 0 && <p>Tax: ${parseFloat(order2Data.total_tax).toFixed(2)}</p>}
                                            {order2Data.total_price != null && <p className="total-amount">Total: ${parseFloat(order2Data.total_price).toFixed(2)}</p>}
                                          </OrderTotalBox>
                                        )}
                                      </OrderTotalsContainer>
                                    )}

                                    {score !== null && score !== undefined && (
                                      <ScoreContainer>
                                        <ScoreHeading>Score: {score}</ScoreHeading>
                                        <ScoreDetail>Time Penalty: {timePenalty}</ScoreDetail>
                                        <ScoreDetail>Unmatched Penalty: {unmatchedPenalty}</ScoreDetail>
                                      </ScoreContainer>
                                    )}

                                    {order1Data && (
                                      <ReceiptSection style={{ flexWrap: 'wrap', gap: '20px', alignItems: 'flex-start' }}>
                                        <div style={{ textAlign: 'center' }}>
                                          <p style={{ fontWeight: 'bold', marginBottom: '8px', color: '#1565c0' }}>Your Order Receipt</p>
                                          <ReceiptPreview
                                            orderData={order1Data}
                                            restaurantName={comparisonResult.restaurantName}
                                            receiptUrl={comparisonResult.traineeOrderReceiptUrl}
                                          />
                                        </div>
                                        {order2Data && (
                                          <div style={{ textAlign: 'center' }}>
                                            <p style={{ fontWeight: 'bold', marginBottom: '8px', color: '#2e7d32' }}>Real Order Receipt</p>
                                            <ReceiptPreview
                                              orderData={order2Data}
                                              restaurantName={comparisonResult.restaurantName}
                                              receiptUrl={comparisonResult.realOrderReceiptUrl}
                                            />
                                          </div>
                                        )}
                                      </ReceiptSection>
                                    )}
                                  </div>
                                  
                                  {receiptPreviews.length > 0 && receiptPreviews.find(rp => rp.orderName === order1Data.name) && (
                                    <div style={{ margin: '15px 0', padding: '10px', backgroundColor: '#f0f8f0', borderRadius: '8px', border: '1px solid #c8e6c9' }}>
                                      <p style={{ fontWeight: 'bold', marginBottom: '8px', color: '#2e7d32' }}>🖨️ Receipt Sent to Test Printer (Job ID: {receiptPreviews.find(rp => rp.orderName === order1Data.name).printJobId})</p>
                                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <div dangerouslySetInnerHTML={{ __html: receiptPreviews.find(rp => rp.orderName === order1Data.name).receiptHtml }} />
                                      </div>
                                    </div>
                                  )}
                                  <StyledButton onClick={() => captureScreenAndCopy(index, order2Data, order1Data)}>{copyStatusMessage}</StyledButton>
                                  {!isLatestLockedOrder && (
                                    <StyledButton onClick={() => handleReview(index)}>
                                      {requireReview[index] ? 'Remove Review Request' : 'Our system made a mistake? Click Here First'}
                                    </StyledButton>
                                  )}
                                  
                                  {/* <StyledButton onClick={() => captureScreenAndDownload(index)}>Download Screenshot</StyledButton> */}
                                  {/* <StyledButton onClick={() => captureScreenAndEmail(index)} disabled={requestStatuses[index] !== 'idle'}>
                                      {buttonText}
                                  </StyledButton> */}
                                </CoolBorder>
                              
                                )
                              );
                            })}
                            {activeCorrectionLock ? (
                              <CorrectionBlockedFooter>
                                Finish the latest correction or submit a system bug report before moving to another training order.
                              </CorrectionBlockedFooter>
                            ) : (
                              !loading && <StyledButton onClick={loadMoreOrders} style={{ margin: '30px' }}>Load More Orders</StyledButton>
                            )}
                            {loading && <ClipLoader color={"#123abc"} loading={loading} css={override} size={150} />}
                          
                            {/* < TwilioPhone comparisonResults={comparisonResults} />   */}

                            
                          </div>
                        ) : (
                          <div>Loading...</div>
                        )}
                    </header>
                  </>
                )
              } />
              <Route path="/score-checker/:orderId" element={<ScoreChecker />} />
              <Route path="/score-checker" element={<ScoreChecker />} />
              <Route path="/trainer/reviews" element={<TrainerReviews />} />
              <Route path="/trainee" element={<TraineeLanding />} />
            </Routes>

            {/* Review Note Modal */}
            {showReviewModal && (
              <ModalOverlay onClick={handleReviewModalCancel}>
                <ModalContent onClick={(e) => e.stopPropagation()}>
                  <ModalTitle>{reviewModalMode === 'bugReport' ? 'Report System Bug' : 'Request a Review'}</ModalTitle>
	                  <ModalSubtitle>
	                    {reviewModalMode === 'bugReport'
	                      ? 'Choose the issue type and explain why this looks like a POS or training system issue.'
	                      : 'Choose the issue type and explain what you noticed. Your note will be checked before it is saved.'}
	                  </ModalSubtitle>
	                  <IssueOptionList>
	                    {REVIEW_ISSUE_OPTIONS.map(option => (
	                      <IssueOptionButton
	                        key={option.id}
	                        type="button"
	                        $selected={reviewModalIssueType === option.id}
	                        onClick={() => {
	                          setReviewModalIssueType(option.id);
	                          setReviewModalError('');
	                        }}
	                        disabled={reviewModalSubmitting}
	                      >
	                        <IssueOptionLabel>{option.label}</IssueOptionLabel>
	                        <IssueOptionDescription>{option.description}</IssueOptionDescription>
	                      </IssueOptionButton>
	                    ))}
	                  </IssueOptionList>
	                  <ModalTextarea
	                    value={reviewModalNote}
	                    onChange={(e) => {
	                      setReviewModalNote(e.target.value);
	                      setReviewModalError('');
	                    }}
	                    placeholder={reviewModalMode === 'bugReport'
	                      ? "Example: The audio says pickup, but the real order has a delivery fee and address."
	                      : "Example: The customer asked for no onions but I couldn't find a 'no onions' option in the system."}
	                    autoFocus
	                    maxLength={500}
	                    disabled={reviewModalSubmitting}
	                  />
	                  <CharCount $warning={reviewModalNote.length > 450}>
	                    {reviewModalNote.length}/500 characters
	                  </CharCount>
	                  {reviewModalError && <ModalError>{reviewModalError}</ModalError>}
	                  <ModalButtonGroup>
                    <ModalButton onClick={handleReviewModalCancel} disabled={reviewModalSubmitting}>
                      Cancel
                    </ModalButton>
	                    <ModalButton
	                      $primary
	                      onClick={handleReviewModalSubmit}
	                      disabled={!reviewModalIssueType || reviewModalNote.trim() === '' || reviewModalSubmitting}
	                    >
                      {reviewModalSubmitting
                        ? 'Sending...'
                        : reviewModalMode === 'bugReport'
                          ? 'Send Bug Report'
                          : 'Submit Review Request'}
                    </ModalButton>
                  </ModalButtonGroup>
                </ModalContent>
              </ModalOverlay>
            )}


        </div>
      </CartProvider>
    </ShopifyProvider>
  );

}






export default App;




//pacificpearltraining.site
